// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1xqti","load6":"Spinner_load6__3wKGW","round":"Spinner_round__2t3dq"};